import { useState, useContext } from "react"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import { Box, Paper, TextField, Tooltip, IconButton, Grid, Typography, MenuItem } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, api, showWarning } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import getIconComponent from "../../utils/getIconComponent"
import Save from "@mui/icons-material/Save"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const StyledRoot = {
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "20px",
  backgroundColor: "#f5f7fa",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
}

const CrearTipoSolicitud = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  // Estado inicial del formulario[cite: 10]
  const [formData, setFormData] = useState({
    tsolcodigo: "",
    tsoldescripcion: "",
    tsolInEg: "",
    tsolstatus: "A",
  })

  // Mutación para guardar la creación[cite: 10]
  const {
    mutateAsync: SaveCreacionTipoSolicitud,
    isPending: isSavingCreacion,
    isError,
  } = useMutation({
    queryKey: ["isCreatingTipoSolicitud"],
    fn: async (data) => {
      const response = await api.post("/TipoSolicitud/createTipoSolicitud", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1), // Retorna a la grilla tras guardar[cite: 10]
  })

  // Manejador de cambios para limpiar y limitar entradas[cite: 10]
  const handleInputChange = (field, value) => {
    let finalValue = value.toUpperCase()

    if (field === "tsolcodigo") finalValue = finalValue.slice(0, 3)
    else if (field === "tsoldescripcion") finalValue = finalValue.slice(0, 60)

    setFormData((prev) => ({ ...prev, [field]: finalValue }))
  }

  // Ejecución y validación al intentar guardar[cite: 10]
  const handleSubmit = async (e) => {
    if (e) e.preventDefault()

    // Validaciones del frontend[cite: 10]
    if (!formData.tsolcodigo.trim()) return showWarning("El Código del Tipo de Solicitud es obligatorio")
    if (!formData.tsoldescripcion.trim()) return showWarning("La Descripción es obligatoria")
    if (!formData.tsolInEg.trim()) return showWarning("Debe seleccionar la Naturaleza de la solicitud")

    await SaveCreacionTipoSolicitud(formData)
  }

  // Configuración de la barra de acciones superior (Solo GRABAR)[cite: 10]
  const guardarAction = selectedMenuInfo?.data?.barraAcciones?.find((action) => action?.acccaption === "GRABAR")

  const toolbarActions = guardarAction
    ? [
        {
          label: guardarAction.acccaption,
          key: guardarAction.acccaption,
          icon: getIconComponent(guardarAction.accnameicono, guardarAction.acctipoico),
        },
      ]
    : [{ label: "Guardar", key: "GUARDAR", icon: <Save /> }]

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        {/* TOP Bar - Botonera[cite: 10] */}
        <Box sx={{ mb: 2 }}>
          {toolbarActions.map((action) => (
            <Tooltip title={action.label} key={action.key}>
              <IconButton
                onClick={handleSubmit}
                disabled={isSavingCreacion}
                sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1 }}
              >
                {action.icon}
              </IconButton>
            </Tooltip>
          ))}
        </Box>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Crear Nuevo Tipo de Solicitud</b>
        </div>

        <CustomBackdrop isLoading={isSavingCreacion} />

        <Box sx={StyledRoot}>
          <Paper
            elevation={3}
            sx={{ p: 4, borderRadius: 3, background: "white" }}
            component="form"
            onSubmit={handleSubmit}
          >
            <Typography variant="h6" color="primary" gutterBottom>
              Datos del Tipo de Solicitud
            </Typography>

            <Grid container spacing={3}>
              {/* CÓDIGO */}
              <Grid item xs={12} sm={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label="Código *"
                  value={formData.tsolcodigo}
                  onChange={(e) => handleInputChange("tsolcodigo", e.target.value)}
                  error={isError && !formData.tsolcodigo}
                  inputProps={{ maxLength: 3 }}
                />
              </Grid>

              {/* DESCRIPCIÓN */}
              <Grid item xs={12} sm={6}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label="Descripción *"
                  value={formData.tsoldescripcion}
                  onChange={(e) => handleInputChange("tsoldescripcion", e.target.value)}
                  error={isError && !formData.tsoldescripcion}
                  inputProps={{ maxLength: 60 }}
                />
              </Grid>

              {/* NATURALEZA (COMBO) */}
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  label="Naturaleza (Ingreso/Egreso) *"
                  value={formData.tsolInEg}
                  onChange={(e) => setFormData((prev) => ({ ...prev, tsolInEg: e.target.value }))}
                  error={isError && !formData.tsolInEg}
                >
                  <MenuItem value="SOLING">INGRESO (SOLING)</MenuItem>
                  <MenuItem value="SOLEGR">EGRESO (SOLEGR)</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default CrearTipoSolicitud
